// extracted by mini-css-extract-plugin
export var hideEditor = "_jw-2";
export var infoIcon = "_jw-3";
export var label = "_jw-1";
export var labelContainer = "_jw-0";
export var readonlyText = "_jw-4";